import { render, staticRenderFns } from "./ExtraServiceCard.vue?vue&type=template&id=21a29384&"
import script from "./ExtraServiceCard.vue?vue&type=script&lang=ts&"
export * from "./ExtraServiceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports